import React from 'react';
import { TreeInputData } from '@zonofi/zono-money-store';
import { TouchableOpacity } from '../../common';
import { SVGS } from '../../assets';
import './tree-filter-item.scss';
import { isEmpty } from 'lodash';

interface TreeNodeItemProps {
  data: TreeInputData;
  onItemPress: (itemId: string, hasChildren?: boolean) => void;
}

export const TreeNodeItem: React.FC<TreeNodeItemProps> = ({
  data,
  onItemPress,
}) => {
  const hasChildren = !!data?.data?.length;

  return (
    <div className="tree-data-item">
      <TouchableOpacity
        onPress={() => onItemPress(data?.id, hasChildren)}
        className={`tree-data-item__view ${hasChildren ? '' : 'gap-view'}`}
        disabled={data?.isDisable}
      >
        {hasChildren ? (
          <>
            <img
              src={SVGS.ArrowRightBlackFill}
              className={data?.selected ? 'rotate-down-icon' : ''}
            />
            <div className="tree-data-item__label font-semibold">
              {data?.label}
            </div>
          </>
        ) : (
          <>
            <img
              src={data?.selected ? SVGS.CheckboxBlack : SVGS.UncheckedBox}
            />
            {data?.emojiId && !isEmpty(data?.emojiId) && (
              <div className="tree-data-item__file-view">
                <div className="tree-data-item__file-view-icon">
                  {data?.emojiId}
                </div>
              </div>
            )}

            <div className="tree-data-item__label font-regular">
              {data?.label}
            </div>
          </>
        )}
      </TouchableOpacity>
      {hasChildren && data?.selected && (
        <div className="tree-node__children">
          {data.data!.map((child) => (
            <TreeNodeItem
              key={child.id}
              data={child}
              onItemPress={onItemPress}
            />
          ))}
        </div>
      )}
    </div>
  );
};
